/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import PDialog from "../components/pos/PDialog";
import db from "../db/db";
import API from "./API";
import Grid from "@mui/material/Grid";
import { CircularProgress } from "@mui/material";
import PConfirm from "../components/pos/PConfirm";
import { Translate } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { AgentUtils } from "./../utils/AgentUtils";
import { Store } from "./../utils/Store";
import { SyncUtils } from "./SyncUtils";
import axios from "axios";

export default function ISync(props) {
  let MOBILE_UI_VERSION = 1;
  let NO_OF_THREADS = 5;
  let BATCH_SIZE = 3000;

  let dataSyncLoop = false;
  let syncedOnce = false;
  let waitLoop = false;
  let waitSec = 5;

  let syncableData = [
    "category",
    "config",
    "setting",
    "tax",
    "vendor",
    "promotion",
    "customer",
    "terminal",
    "product",
    "file",
    "export_profile_config",
    "floor",
    "fxrate",
    "cost",
  ];

  const { t } = useTranslation();
  const translate = t;

  const [showSyncDialog, setShowSyncDialog] = useState(false);
  const [terminalBean, setTerminalBean] = useState(null);
  const [message, setMessage] = useState("Loading...");

  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  let cache = [];
  let prodCache = [];

  useEffect(() => {
    if (terminalBean) {
      //console.log("ISync terminal Bean mounted");
      waitLoop = false;
    }
  }, [terminalBean]);

  useEffect(() => {
    //syncData();
    dataSyncLoop = true;
    syncedOnce = false;

    syncData();
    tokenWatcher();
    return function cleanup() {
      //console.log("Sync Stopped");
      dataSyncLoop = false;
      syncedOnce = false;
    };
  }, []);

  async function tokenWatcher() {
    let token = localStorage.getItem("w_accessToken");
    let t2 = new Date().getTime();
    while (dataSyncLoop) {
      try {
        if (isTokenExpired(token)) {
          console.log("Token Expired", new Date());
          let rToken = localStorage.getItem("w_refreshToken");
          console.log("Isync Login");
          const response = await fetch(
            props.baseUrl + "/auth/v1/users/signin",
            {
              method: "post",
              body: JSON.stringify({
                token: rToken,
              }),
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            localStorage.setItem("w_accessToken", data.accessToken);
            localStorage.setItem("w_refreshToken", data.refreshToken);

            API.defaults.headers.common = {
              Authorization: `Bearer ${data.refreshToken}`,
              baseURL: props.baseUrl,
            };
            token = localStorage.getItem("w_accessToken");
          } else {
            props.onLogOut();
          }
        }
      } catch (err) {
        console.log(err);
      }
      await sleep(1000);
    }
  }

  function isTokenExpired(token) {
    const expiry = JSON.parse(atob(token.split(".")[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }
  async function syncData() {
    let lastUpgCheck = 0;
    let syncCount = 0;
    setShowSyncDialog(true);
    /*setMessage("PUSHING DATA...");
    let dataType = ["sale", "sale_return", "sale_order"];
    for (let type of dataType) {
      const all = await db.table(type).toArray();
      for (let s of all) {
        try {
          let { data } = await API.get("/api/v1/" + type + "/" + s.id);
        } catch (err) {
          console.log(err.response);
          if (err.response.status == 404) {
            let { data } = await API.post("/api/v1/" + type + "", s);
          }
        }
      }
    }*/
    while (dataSyncLoop) {
      try {
        if (!syncedOnce) {
          setShowSyncDialog(true);
        }
        ///////// SYNC START
        let dbData = await db.table("sync_head").get("lastRef");
        if (!dbData) {
          let { data } = await API.get("/api/v1/sync/head");
          //console.log(data);
          ////console.log("Need Full Refresh" + data[0].lastRef);
          setMessage("Analysing...");

          let dMap = { category: {}, tax: {}, vendor: {} };

          let t1 = new Date();

          var objCount = {};
          var total = 0;
          for (let i = 0; i < syncableData.length; i++) {
            let table = syncableData[i];
            const { data } = await API.get("/api/v1/count/" + table);
            objCount[table] = parseInt(data);
            total = total + parseInt(data);
          }

          //console.log(JSON.stringify(objCount, null, 4));

          setMessage("Loading... 0 %");

          let progressMeta = { total: total, processed: 0, prevPersentage: 0 };

          for (let i = 0; i < syncableData.length; i++) {
            let table = syncableData[i];
            await db.table(table).clear();

            const idsData = await API.get("/api/v1/ids/" + table);
            let ids = idsData.data;

            let isProduct = "product" === table;

            let req = [];

            await loadDataV2(table, ids, dMap, progressMeta);

            //return;

            /*for (let j = 0; j < ids.length; j++) {
              req.push(ids[j]);
              if (j % 3000 == 0) {
                //batch it

                let dbData = await loadData(table, req, isProduct, dMap);

                if (["tax", "vendor", "category"].includes(table)) {
                  updateTableMap(table, dMap, dbData);
                }
                await db.table(table).bulkAdd(dbData);
                //console.log("buklAdd took" + (t2 - t1) + " ms");
                req = [];
              }
              
            }
            if (req.length > 0) {
              let dbData = await loadData(table, req, isProduct, dMap);

              if (["tax", "vendor", "category"].includes(table)) {
                updateTableMap(table, dMap, dbData);
              }
              await db.table(table).bulkAdd(dbData);
              //console.log("buklAdd took" + (t2 - t1) + " ms");
            }*/
          }

          await db.table("sync_head").add({
            key: "lastRef",
            value: data[0].lastRef,
          });
          let t2 = new Date();
          console.log("Data Loading took ", t2 - t1 + " Ms");
        }
        //PUSH Data

        setMessage("Pushing Data...");

        let syncMeta = await db.sync_meta.orderBy(":id").toArray();
        //console.log("SYNC META");

        for (let meta of syncMeta) {
          //console.log(meta);
          if (meta.tableName === "sale") {
            try {
              let payload = await db.sale.get(meta.tableIdentifier);
              let { data } = await API.post("/api/v1/sale", payload);

              await db.sync_meta.delete(meta.id);
              await db.sale.delete(meta.id);
              //console.log("Sale Saved");
            } catch (err) {
              console.log("Error ", err);
            }
          } else if (meta.tableName === "sale_return") {
            try {
              let payload = await db.sale_return.get(meta.tableIdentifier);
              let { data } = await API.post("/api/v1/sale_return", payload);

              await db.sync_meta.delete(meta.id);
              await db.sale_return.delete(meta.id);
              //console.log("Sale Saved");
            } catch (err) {
              console.log("Error ", err);
            }
          } else if (meta.tableName === "service") {
            try {
              let payload = await db.service.get(meta.tableIdentifier);
              let { data } = await API.post("/api/v1/service", payload);
              await db.sync_meta.delete(meta.id);
              await db.service.delete(meta.id);
              //console.log("Sale Saved");
            } catch (err) {
              console.log("Error ", err);
            }
          } else if (meta.tableName === "sale_order") {
            try {
              let payload = await db.sale_order.get(meta.tableIdentifier);
              let { data } = await API.post("/api/v1/sale_order", payload);
              await db.sync_meta.delete(meta.id);
              await db.service.delete(meta.id);
              //console.log("Sale Saved");
            } catch (err) {
              console.log("Error ", err);
            }
          }
          if (meta.tableName === "sale_hold") {
            try {
              let payload = await db.sale_hold.get(meta.tableIdentifier);
              let { data } = await API.post("/api/v1/sale_hold", payload);

              await db.sync_meta.delete(meta.id);
              await db.sale_hold.delete(meta.id);
              //console.log("Sale Saved");
            } catch (err) {
              console.log("Error ", err);
            }
          } else if (meta.tableName === "sale_return_hold") {
            try {
              let payload = await db.sale_return_hold.get(meta.tableIdentifier);
              let { data } = await API.post(
                "/api/v1/sale_return_hold",
                payload
              );

              await db.sync_meta.delete(meta.id);
              await db.sale_return_hold.delete(meta.id);
              //console.log("Sale Saved");
            } catch (err) {
              console.log("Error ", err);
            }
          } else if (meta.tableName === "service_hold") {
            try {
              let payload = await db.service_hold.get(meta.tableIdentifier);
              let { data } = await API.post("/api/v1/service_hold", payload);
              await db.sync_meta.delete(meta.id);
              await db.service_hold.delete(meta.id);
              //console.log("Sale Saved");
            } catch (err) {
              console.log("Error ", err);
            }
          } else if (meta.tableName === "sale_order_hold") {
            try {
              let payload = await db.sale_order_hold.get(meta.tableIdentifier);
              let { data } = await API.post("/api/v1/sale_order_hold", payload);
              await db.sync_meta.delete(meta.id);
              await db.sale_order_hold.delete(meta.id);
              //console.log("Sale Saved");
            } catch (err) {
              console.log("Error ", err);
            }
          } else if (meta.tableName === "customer") {
            try {
              if (meta.operationType === "DELETE") {
                let result = await API.delete(
                  "/api/v1/customer/" + meta.tableIdentifier
                );
              } else {
                let payload = await db.customer.get(meta.tableIdentifier);
                let { data } = await API.post("/api/v1/customer", payload, {
                  headers: { ignoreOptimisticLocking: true },
                });
              }
              await db.sync_meta.delete(meta.id);
            } catch (err) {
              console.log("Error ", err);
            }
          }
        }
        if (syncCount != 1) setMessage("Pulling Data...");

        //Analyse

        dbData = await db.table("sync_head").get("lastRef");

        let data = null;
        if (syncCount == 1) {
          setMessage("Verifying Data...");
          data = await verifyData();
        } else {
          let pullRefResult = await API.get(
            "/e_api/v1/sync/pullRef/" + dbData.value
          );
          data = pullRefResult.data;
        }

        const d = new Date();
        let time = d.getTime();
        if (time > lastUpgCheck + 10800000) {
          lastUpgCheck = time;
          if (MOBILE_UI_VERSION < data.min_mobile_ui_version) {
            setConfirmOpen(true);
            setConfirmContext({
              title: translate("Upgrade Required"),
              message: translate("New Version is available , Please Upgrade"),
              type: "warning",
              open: true,
              yes: true,
              no: true,
              yesLabel: translate("Upgrade"),
              noLabel: translate("Later"),
            });
          }
        }
        if (data.lastRef === dbData.value) {
          ////console.log("Nothing to Refresh");
        } else {
          if (data.transactions.length > 0) {
            let request = {};
            let deleteRequest = {};
            for (let i = 0; i < data.transactions.length; i++) {
              //console.log(
              // "SYNC" + JSON.stringify(data.transactions[i].transType, null, 2)
              //  );
              if (data.transactions[i].transType === "SAVE") {
                var refs = data.transactions[i].objectRefs;
                ////console.log(refs);
                Object.keys(refs).forEach(function (key) {
                  let arr = refs[key];
                  if (!request[key]) {
                    request[key] = new Set();
                  }
                  for (let k = 0; k < arr.length; k++) {
                    request[key].add(arr[k]);
                  }
                });
              } else if (data.transactions[i].transType === "DELETE") {
                var refs1 = data.transactions[i].objectRefs;
                ////console.log(refs);
                Object.keys(refs1).forEach(function (key) {
                  let arr = refs1[key];
                  if (!deleteRequest[key]) {
                    deleteRequest[key] = new Set();
                  }
                  for (let k = 0; k < arr.length; k++) {
                    deleteRequest[key].add(arr[k]);
                  }
                });
              } else if (
                data.transactions[i].transType === "EJECT_USER" &&
                syncedOnce
              ) {
                console.log(
                  "Eject User COmmand Received",
                  data.transactions[i]
                );
                let cmd = data.transactions[i];
                let accessTokenHash = Store.hashCode(
                  localStorage.getItem("w_accessToken")
                );
                console.log(localStorage.getItem("w_accessToken"));
                let jwt = Store.parseJwt(localStorage.getItem("w_accessToken"));

                let isSameUser = jwt.sub === cmd.command.userName;
                if (
                  cmd.command.accessTokenHash != accessTokenHash &&
                  isSameUser
                ) {
                  console.log("Log Out");
                  props.onLogOut();
                }
              } else if (
                data.transactions[i].transType === "QUEUE_REFRESH" &&
                syncedOnce
              ) {
                props.queueRefresh(data.transactions[i]);
              }
            }
            if (syncCount != 1) setMessage("Loading... 0 %");

            let processed = 0;
            let prevPersentage = 0;

            //SAVE
            var keys = Object.keys(request);

            //console.log("keys", keys);

            let total = 0;

            for (var ii = 0; ii < keys.length; ii++) {
              var key11 = keys[ii];
              var found11 = syncableData.find(function (element) {
                return element == key11;
              });
              if (found11) {
                total = total + request[key11].size;
              }
            }
            //console.log("TOTAl TO SYNC", total);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var found = syncableData.find(function (element) {
                return element == key;
              });
              if (found) {
                //this.setState({ dataLoadMessage: "Syncing " + key + "s" });

                ///////////////////////////////  START
                let req = [];
                for (let j = 0; j < request[key].size; j++) {
                  //console.log("REQ1", request[key], j);
                  let array = Array.from(request[key]);
                  //Array.from(request[key][j]);
                  req.push(array[j]);
                  if (j % 1000 == 0) {
                    //batch it
                    //console.log("REQ", req);
                    let dataToUpdate = [];
                    if (key == "product") {
                      dataToUpdate = await API.post("e_api/v1/sync/pullData", {
                        objectType: "product",
                        ids: Array.from(req),
                      });
                      await fillData(key, dataToUpdate);
                    } else if (key == "cost") {
                      dataToUpdate = await API.post("e_api/v1/sync/pullData", {
                        objectType: "cost",
                        ids: Array.from(req),
                      });
                    } else {
                      dataToUpdate = await API.post(
                        "/api/v1/" + key + "list",
                        req
                      );
                    }

                    let t1 = new Date().getTime();
                    let dataToSave = await reconcileData(key, dataToUpdate);
                    if (dataToSave.length > 0)
                      await db.table(key).bulkPut(dataToSave);

                    let t2 = new Date().getTime();
                    //console.log("buklAdd took" + (t2 - t1) + " ms");
                    await saveEvent("save", key, dataToSave);
                    req = [];
                    console.log("Done");
                  }
                  processed++;
                  let per = (processed / total) * 100;
                  per = per | 0;
                  if (per > prevPersentage) {
                    prevPersentage = per;
                    setMessage("Loading... " + per + " %");
                  }
                }
                if (req.length > 0) {
                  let dataToUpdate = [];
                  if (key == "product") {
                    dataToUpdate = await API.post("e_api/v1/sync/pullData", {
                      objectType: "product",
                      ids: Array.from(req),
                    });
                    await fillData(key, dataToUpdate);
                  } else if (key == "cost") {
                    dataToUpdate = await API.post("e_api/v1/sync/pullData", {
                      objectType: "cost",
                      ids: Array.from(req),
                    });
                  } else {
                    dataToUpdate = await API.post(
                      "/api/v1/" + key + "list",
                      req
                    );
                  }

                  let t1 = new Date().getTime();
                  let dataToSave = await reconcileData(key, dataToUpdate);
                  if (dataToSave.length > 0)
                    await db.table(key).bulkPut(dataToSave);
                  let t2 = new Date().getTime();
                  await saveEvent("save", key, dataToSave);

                  //console.log("buklAdd took" + (t2 - t1) + " ms");
                }

                /////////////////////////// END
                /*let data2 = await API.post(
                  "/api/v1/" + key + "list",
                  Array.from(request[key])
                );
                await db.table(key).bulkPut(data2.data);*/
              }
            }

            //DELETE
            keys = Object.keys(deleteRequest);
            for (var i1 = 0; i1 < keys.length; i1++) {
              var key1 = keys[i1];
              var found1 = syncableData.find(function (element) {
                return element === key1;
              });
              if (found1) {
                await db
                  .table(key1)
                  .bulkDelete(Array.from(deleteRequest[key1]));

                await deleteEvent("delete", key1, deleteRequest[key1]);
              }
            }
          }
          if (syncCount != 1) {
            await db.table("sync_head").update("lastRef", {
              key: "lastRef",
              value: data.lastRef,
            });
          }
          //console.log("sync_head");
        }

        if (syncCount > 1 && !syncedOnce) {
          setMessage("Intializing Cache");
          let [prodSearchCache, productCache] =
            await SyncUtils.getProductData();
          cache = prodSearchCache;
          prodCache = productCache;
          props.setProductCache(productCache);
          props.setProductSearchCache(prodSearchCache);

          setShowSyncDialog(false);
          props.onDataLoaded();
          syncedOnce = true;
        }
        syncCount++;
      } catch (e) {
        console.log(e);
        let count = 0;
        while (waitLoop && count < waitSec) {
          await sleep(1000);
          count = count + 1;
        }
      }
      waitLoop = true;
      let count = 0;
      while (waitLoop && count < waitSec) {
        await sleep(1000);
        count = count + 1;
      }
    }
  }

  async function fillData(key, objects) {
    if (key === "product") {
      for (let p of objects.data) {
        if (p.deptId) {
          let catBean = await db.category.get(p.deptId);
          p["deptBean"] = catBean;
        }
        if (p.subDeptId) {
          let catBean = await db.category.get(p.subDeptId);
          p["subDeptBean"] = catBean;
        }
        if (p.catId) {
          let catBean = await db.category.get(p.catId);
          p["catBean"] = catBean;
        }
        if (p.subCatId) {
          let catBean = await db.category.get(p.subCatId);
          p["subCatBean"] = catBean;
        }
        if (p.vendorBean) {
          let vendorBean = await db.vendor.get(p.vendorBean.$id);
          p["vendorBean"] = vendorBean;
        }
        if (p.taxBean) {
          let taxBean = await db.tax.get(p.taxBean.$id);
          p["taxBean"] = taxBean;
        }
      }
    }
  }

  async function loadDataV2(table, ids, dMap, progressMeta) {
    console.log(table, ids.length);

    let requests = [];
    let req = [];

    for (let j = 0; j < ids.length; j++) {
      req.push(ids[j]);
      if (j > 0 && j % BATCH_SIZE == 0) {
        if (table === "product" || table === "cost") {
          try {
            requests.push({
              api: "e_api/v1/sync/pullData",
              payload: {
                ids: Array.from(req),
                objectType: table,
              },
            });
          } catch (err) {
            requests.push({
              api: "/api/v1/" + table + "list",
              payload: Array.from(req),
            });
          }
        } else {
          requests.push({
            api: "/api/v1/" + table + "list",
            payload: Array.from(req),
          });
        }
        req = [];
      }
    }
    if (req.length > 0) {
      if (table === "product" || table === "cost") {
        try {
          requests.push({
            api: "e_api/v1/sync/pullData",
            payload: {
              ids: Array.from(req),
              objectType: table,
            },
          });
        } catch (err) {
          //requests.push(API.post("/api/v1/" + table + "list", Array.from(req)));
          requests.push({
            api: "/api/v1/" + table + "list",
            payload: Array.from(req),
          });
        }
      } else {
        requests.push({
          api: "/api/v1/" + table + "list",
          payload: Array.from(req),
        });
      }
      req = [];
    }
    let result = await executeRequestsInParallel(
      requests,
      NO_OF_THREADS,
      progressMeta
    );
    if (table === "product") {
      backFillProduct(result, dMap);
    }
    if (["tax", "vendor", "category"].includes(table)) {
      updateTableMap(table, dMap, result);
    }
    await db.table(table).bulkAdd(result);
  }

  async function executeRequestsInParallel(requests, noThreads, progressMeta) {
    let req = [];
    let result = [];
    for (let i = 0; i < requests.length; i++) {
      req.push(API.post(requests[i].api, requests[i].payload));
      if (i > 0 && (i + 1) % noThreads == 0) {
        let res = await axios.all(req);

        for (let r of res) {
          for (let x of r.data) {
            result.push(x);
            progressMeta.processed++;
          }
        }

        let per = (progressMeta.processed / progressMeta.total) * 100;
        per = per | 0;
        if (per > progressMeta.prevPersentage) {
          progressMeta.prevPersentage = per;
          if (per > 100) {
            per = 100;
          }
          setMessage("Loading... " + per + " %");
        }
        req = [];
      }
    }
    if (req.length > 0) {
      let res = await axios.all(req);
      for (let r of res) {
        for (let x of r.data) {
          result.push(x);
        }
      }
    }
    return result;
  }

  /*async function loadData(table, req, isProduct, dMap) {
    let dbData;
    if (table === "product" || table === "cost") {
      try {
        let objs = await API.post("e_api/v1/sync/pullData", {
          ids: Array.from(req),
          objectType: table,
        });
        dbData = objs.data;
        if (table === "product") {
          backFillProduct(dbData, dMap);
        }
      } catch (err) {
        let objs = await API.post("/api/v1/" + table + "list", Array.from(req));
        dbData = objs.data;
      }
    } else {
      let objs = await API.post("/api/v1/" + table + "list", Array.from(req));
      dbData = objs.data;
    }
    return dbData;
  }*/

  async function verifyData() {
    let res = {
      min_mobile_ui_version: 1,
      min_web_ui_version: 1,
      min_android_version: 1,
      transactions: [
        { objectRefs: {}, transType: "SAVE" },
        { objectRefs: {}, transType: "DELETE" },
      ],
    };

    let hashFromServer = {};
    let requests = [];
    for (let dataType of syncableData) {
      if ("sequence" === dataType) {
        continue;
      }
      requests.push(
        API.post("e_api/v1/sync/getHash", {
          datatypes: [dataType],
        })
      );
    }

    let getHashResults = await axios.all(requests);

    let ix = 0;

    for (let dataType of syncableData) {
      if ("sequence" === dataType) {
        continue;
      }
      setMessage(
        "Verifying Data - " +
          (dataType == "export_profile_config" ? "Export Profile" : dataType)
      );

      /*let { data } = await API.post("e_api/v1/sync/getHash", {
        datatypes: [dataType],
      });*/

      let data = getHashResults[ix].data;
      ix++;

      let lclHash = await SyncUtils.getHashMapFromDb(dataType);
      let ids = [];
      for (const [key, value] of Object.entries(data[dataType])) {
        if (lclHash[key] && lclHash[key] == value) {
          //console.log("Object Exists");
        } else {
          ids.push(key);
          //console.log("Object Not Exists");
        }
      }
      if (ids.length > 0) {
        console.log("Difference Detected for " + dataType, ids);
        res.transactions[0].objectRefs[dataType] = ids;
      }
      //console.log(dataTypes, ids);
    }
    return res;
  }

  function updateTableMap(table, dMap, dbData) {
    for (let d of dbData) {
      dMap[table][d.id] = d;
    }
  }

  function backFillProduct(data, dMap) {
    for (let p of data) {
      //console.log("Before", JSON.stringify(p));
      p.deptBean = dMap["category"][p.deptId];
      p.subDeptBean = dMap["category"][p.subDeptId];
      p.catBean = dMap["category"][p.catid];
      p.subCatBean = dMap["category"][p.subCatId];
      p.taxBean = dMap["tax"][p.taxId];
      p.vendorBean = dMap["vendor"][p.vendorId];
      //console.log("After", JSON.stringify(p));
    }
  }

  async function reconcileData(key, data) {
    return data.data;
  }
  async function deleteEvent(action, type, data) {
    if ("product" === type && action == "delete") {
      console.log(data);

      let arr = [];
      for (let c of prodCache) {
        if (data.has(c.id)) {
        } else {
          arr.push(c);
        }
      }

      let newArr = [];
      for (let c of cache) {
        if (data.has(c.id)) {
        } else {
          newArr.push(c);
        }
      }
      props.setProductCache(arr);
      props.setProductSearchCache(newArr);
    }
  }
  async function saveEvent(action, type, data) {
    if ("terminal" === type && action == "save") {
      let lclTerm = localStorage.getItem("w_terminal");
      if (lclTerm) {
        let lcltermbean = JSON.parse(lclTerm);
        for (let d of data) {
          if (lcltermbean.id == d.id) {
            localStorage.setItem("w_terminal", JSON.stringify(d));
          }
        }
      }
    }

    if ("product" === type && action == "save") {
      let startTime = new Date();
      let cnt = await db.product.count();
      /*if (cache.length < cnt) {
        console.log("FULL REFRESH");
        let [search, prod] = await SyncUtils.getProductData();
        props.setProductSearchCache(search);
        return;
      }*/
      let sCache = [...cache];
      let pCache = [...prodCache];
      for (let d of data) {
        let found = false;
        for (let i = 0; i < pCache.length; i++) {
          if (pCache[i].id == d.id) {
            found = true;
            pCache[i] = SyncUtils.getCacheData(d);
          }
        }
        if (!found) {
          pCache.push(SyncUtils.getCacheData(d));
        }

        found = false;
        let dbUnitTypes = {};
        let cacheUnitTypes = {};
        for (let pr of d.productPricingBeanList) {
          dbUnitTypes[pr.unitType] = pr;
        }

        for (let i = 0; i < sCache.length; i++) {
          if (sCache[i].id == d.id) {
            cacheUnitTypes[sCache[i].unitType] = {
              ix: i,
            };
            found = true;
          }
        }

        if (found) {
          for (let unitType in dbUnitTypes) {
            if (cacheUnitTypes[unitType]) {
              //Update
              sCache[cacheUnitTypes[unitType].ix] =
                SyncUtils.getSearchCacheDataForUnitType(d, unitType);
            } else {
              //New Price
              sCache.push(SyncUtils.getSearchCacheDataForUnitType(d, unitType));
            }
          }

          let rmIx = [];
          for (let unitType in cacheUnitTypes) {
            if (!dbUnitTypes[unitType]) {
              //Mark for Removal
              rmIx.push(cacheUnitTypes[unitType].ix);
            }
          }
          //Remove
          rmIx.sort(function (a, b) {
            return b - a;
          });
          for (let r of rmIx) {
            sCache.splice(r, 1);
          }
        } else {
          SyncUtils.getSearchCacheData(d, sCache);
        }
      }

      /*let cache = [...productCache1];
      let sCache = [...productSearchCache1];
      for (let d of data) {
        let found = false;

        for (let i = 0; i < cache.length; i++) {
          if (d.id == cache[i].id) {
            cache[i] = SyncUtils.getCacheData(d);
            found = true;
          }
        }
        if (found) {
          let dbUnitTypes = {};
          let cacheUnitTypes = {};
          for (let pr of d.productPricingBeanList) {
            dbUnitTypes[pr.unitType] = pr;
          }
          for (let i = 0; i < sCache.length; i++) {
            if (sCache[i].id == d.id) {
              cacheUnitTypes[sCache[i].unitType] = {
                ix: i,
              };
            }
          }
          for (let unitType in dbUnitTypes) {
            if (cacheUnitTypes[unitType]) {
              //Update
              sCache[cacheUnitTypes[unitType].ix] =
                SyncUtils.getSearchCacheDataForUnitType(d, unitType);
            } else {
              //New Price
              sCache.push(SyncUtils.getSearchCacheDataForUnitType(d, unitType));
            }
          }
          let rmIx = [];
          for (let unitType in cacheUnitTypes) {
            if (!dbUnitTypes[unitType]) {
              //Mark for Removal
              rmIx.push(cacheUnitTypes[unitType].ix);
            }
          }
          //Remove
          rmIx.sort(function (a, b) {
            return b - a;
          });
          for (let r of rmIx) {
            sCache.splice(r, 1);
          }
        } else {
          cache.push(SyncUtils.getCacheData(d));
          SyncUtils.getSearchCacheData(d, sCache);
        }
      }*/
      cache = sCache;
      prodCache = pCache;
      props.setProductSearchCache(sCache);
      props.setProductCache(pCache);

      let timeDiff = new Date() - startTime; //in ms
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function onYesNoClicked(context, value, contextType, callbackRef) {
    setConfirmOpen(false);

    if ("yes" === value) {
      if (AgentUtils.isAndroid()) {
        window.location.reload();
      } else {
        window.location.reload();
      }
    }
    if ("no" === value) {
      console.log("No Clicked");
    }
  }

  return (
    <div>
      {showSyncDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 250, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {message}
              </Grid>
            </Grid>
          }
          maxWidth={"md"}
          fullWidth={false}
          open={true}
          borderLess={true}
        ></PDialog>
      )}
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
